export default __webpack_public_path__ + "static/media/EM0630.34I-22015_-15002_0.f6382230.jpg";